import * as Yup from 'yup';

const requiredMessage: string = 'Wartość jest wymagana';

export const CloneFormVersionValidationSchema = Yup.object().shape({
	formVersionId: Yup.string().required(requiredMessage),
});
